// save ไว้ที่ D:\vuejs\project\tai_book\src\store\api\services\prService.js
import Api from '@/services/Api'
import router from '@/router'
import store from '@/store'

export default {
  // prdocrem Service ------------------------------------
  prCurrentBudgetYear() {
    let d = new Date()
    let Y = d.getFullYear() +543
    let M = d.getMonth()+1
    if (M >= 10) {
      Y++
    }
    return Y
  },
  prtest() {
    return 2564
  },
  prdocremList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'pr/default.asp?controller=prdocrem&action=list' + param,
      credentials
    )
  },
  prdocremItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'pr/default.asp?controller=prdocrem&action=listbyparam' ,
      credentials
    )
  },
  prdocremListByParam(credentials) {
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'pr/default.asp?controller=prdocrem&action=listbyparam'+ param,
      credentials
    )
  },
  prdocremInsert(credentials) {
    console.log('credentials', credentials)
    return Api.httpServer().post(
      'pr/default.asp?controller=prdocrem&action=insert',
      credentials
    )
  },
  prdocremUpdate(credentials) {
    return Api.httpServer().post(
      'pr/default.asp?controller=prdocrem&action=update',
      credentials
    )
  },
  prdocremDelete(credentials) {
    return Api.httpServer().post(
      'pr/default.asp?controller=prdocrem&action=delete',
      credentials
    )
  },
  // prdocdt Service ------------------------------------
  prItemHistory(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'pr/default.asp?controller=prdochd&action=prItemHistory' + param,
      credentials
    )
  },
  
  prHistory(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'pr/default.asp?controller=prdochd&action=prHistory' + param,
      credentials
    )
  },

  prdocdtList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'pr/default.asp?controller=prdocdt&action=list' + param,
      credentials
    )
  },
  prdocdtItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'pr/default.asp?controller=prdocdt&action=listbyparam' ,
      credentials
    )
  },
  prdocdtListByParam(credentials) {
    let param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }    
    return Api.httpServer().post(
      'pr/default.asp?controller=prdocdt&action=listbyparam' + param,
      credentials
    )
  },
  prdocdtBalanceOld(credentials) {
    return Api.httpServer().post(
      'pr/default.asp?controller=prdocdt&action=BalanceOld',
      credentials
    )
  },    
  prdocdtBalance(credentials) {
    return Api.httpServer().post(
      'pr/default.asp?controller=prdocdt&action=Balance',
      credentials
    )
  },    
  prdocdtInsert(credentials) {
    return Api.httpServer().post(
      'pr/default.asp?controller=prdocdt&action=insert',
      credentials
    )
  },
  prdocdtUpdate(credentials) {
    return Api.httpServer().post(
      'pr/default.asp?controller=prdocdt&action=update',
      credentials
    )
  },
  prdocdtDelete(credentials) {
    return Api.httpServer().post(
      'pr/default.asp?controller=prdocdt&action=delete',
      credentials
    )
  },
  // prdochd Service ------------------------------------
  prdochdList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'pr/default.asp?controller=prdochd&action=list' + param,
      credentials
    )
  },
  prdochdItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'pr/default.asp?controller=prdochd&action=listbyid' ,
      credentials
    )
  },
  prdochdListByParam(credentials) {
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }    
    return Api.httpServer().post(
      'pr/default.asp?controller=prdochd&action=listbyparam' + param,
      credentials
    )
  },
  prdochdBalance(credentials) {
    return Api.httpServer().post(
      'pr/default.asp?controller=prdochd&action=Balance',
      credentials
    )
  },
  prdochdInsert(credentials) {
    return Api.httpServer().post(
      'pr/default.asp?controller=prdochd&action=insert',
      credentials
    )
  },
  prdochdUpdate(credentials) {

    return Api.httpServer().post(
      'pr/default.asp?controller=prdochd&action=update',
      credentials
    )
  },
  prdochdAppv(credentials) {

    return Api.httpServer().post(
      'pr/default.asp?controller=prdochd&action=appv',
      credentials
    )
  },
  prdochdAppvPO(credentials) {

    return Api.httpServer().post(
      'pr/default.asp?controller=prdochd&action=appvpo',
      credentials
    )
  },
  prdochdDelete(credentials) {
    return Api.httpServer().post(
      'pr/default.asp?controller=prdochd&action=delete',
      credentials
    )
  },
  prdochdAppvBy(credentials) {
    return Api.httpServer().post(
      'pr/default.asp?controller=prdochd&action=appvby',
      credentials
    )
  },
  // prconfig Service ------------------------------------
  prconfigList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'pr/default.asp?controller=prconfig&action=list' + param,
      credentials
    )
  },
  prconfigItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'pr/default.asp?controller=prconfig&action=listbyparam' ,
      credentials
    )
  },
  prconfigListByParam(credentials) {
    return Api.httpServer().post(
      'pr/default.asp?controller=prconfig&action=listbyparam',
      credentials
    )
  },
  prconfigInsert(credentials) {
    return Api.httpServer().post(
      'pr/default.asp?controller=prconfig&action=insert',
      credentials
    )
  },
  prconfigUpdate(credentials) {
    return Api.httpServer().post(
      'pr/default.asp?controller=prconfig&action=update',
      credentials
    )
  },
  prconfigDelete(credentials) {
    return Api.httpServer().post(
      'pr/default.asp?controller=prconfig&action=delete',
      credentials
    )
  },
  
  // podochd Service ------------------------------------
  podochdList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'pr/default.asp?controller=podochd&action=list' + param,
      credentials
    )
  },
  podochdItemById(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'pr/default.asp?controller=podochd&action=listbyid' ,
      credentials
    )
  },
  podochdListByParam(credentials) {
    // var param = '&pageno=' + credentials.pageNo
    // param += '&rowperpage=' + credentials.rowsPerPage
    // param += '&search=' + encodeURIComponent(credentials.search)    
    return Api.httpServer().post(
      'pr/default.asp?controller=podochd&action=listbyparam' ,
      credentials
    )
  },
  podochdInsert(credentials) {
    return Api.httpServer().post(
      'pr/default.asp?controller=podochd&action=insert',
      credentials
    )
  },
  podochdUpdate(credentials) {
    return Api.httpServer().post(
      'pr/default.asp?controller=podochd&action=update',
      credentials
    )
  },
  podochdDelete(credentials) {
    return Api.httpServer().post(
      'pr/default.asp?controller=podochd&action=delete',
      credentials
    )
  },
//<services>
  errorHandel(res) {
    if(res) {
      if (res.status === 401) {
        store.state.users.main = {}
        router.push('/signin')
      }
    }
  }
}
